/* unplugin-vue-components disabled */import { render } from "./CollectBase.vue?vue&type=template&id=a7b7f89a"
import script from "./CollectBase.vue?vue&type=script&lang=js"
export * from "./CollectBase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__